import { canUseDom } from './utils/canUse'

export class StorageSdk {
  localStorage = (): Storage | null => (canUseDom() ? localStorage : null)

  sessionStorage = (): Storage | null => (canUseDom() ? sessionStorage : null)
}

// STORAGE KEYS
export const EMAIL_HIDDEN_STORAGE = 'ivts-emailHidden'
export const EMAIL_STRONG_STORAGE = 'ivts-emailStrong'
export const EMAIL_STRONGER_STORAGE = 'ivts-emailStronger'
export const NAVIGATION_PREVIOUS_STORAGE = 'ivts-previousPageDatas'
export const VISITOR_TYPE_STORAGE = 'ivts-visitorType'
export const FIRST_VISIT_STORAGE = 'ivts-firstVisit'
export const EVENT_TO_CONSENT_STORAGE = 'ivts-event-pending'
export const EVENTS_PUSH_STORAGE = 'ivts-events-push'
export const EVENTS_CLICK_STORAGE = 'ivts-events-click'
export const TRACE_ID_STORAGE = 'ivts-trace-id'
export const CONSENT_VENDORS_S2S_STORAGE = 'ivts-con-v'
export const CONSENT_VENDORS_ALL_STORAGE = 'ivts-con-v-all'
export const CONSENT_VENDORS_FILTER_STORAGE = 'ivts-con-v-filter'
export const CONSENT_STRING_STORAGE = 'ivts-con-s'
export const CONSENT_ID_STORAGE = 'ivts-con-id'
export const EXEMPT_ID_STORAGE = 'ivts-con-ex'
export const ATTRIBUTION_MEDIUM_STORAGE = 'attribution-medium'
export const ATTRIBUTION_SOURCE_STORAGE = 'attribution-source'
export const ATTRIBUTION_CAMPAIGN_STORAGE = 'attribution-campaign'
export const ATTRIBUTION_CONTENT_STORAGE = 'attribution-content'
export const ATTRIBUTION_TERM_STORAGE = 'attribution-term'
export const ATTRIBUTION_CRM_STORAGE = 'attribution-crm'
export const ATTRIBUTION_CLID_STORAGE = 'attribution-clid'
export const ATTRIBUTION_GCLID_STORAGE = 'attribution-gclid'
export const ITINERARY_ID_STORAGE = 'itineraryId'
export const ZEMANTA_ID_STORAGE = 'ivts-zemanta-id'
export const SEARCH_USAGE_STORAGE = 'ivts-search-usage'
export const THEME_STORAGE = 'theme'
export const DEFAULT_THEME_STORAGE = 'system'
